<div class="PGEmail input-group">
        <input [id]="fieldId" class="form-control" [disabled]="readonly" [required]="required"
                [attr.aria-invalid]="ariaInvalid || null" [attr.aria-describedby]="ariaDescribedBy || null"
                [(ngModel)]="value" (ngModelChange)="onValueChange()"/>
</div>
